import React from 'react';
import './expenses-view.css';
import '../../styles/list-glass.css';
import { Redirect, Link } from "react-router-dom";
import SpinnerView from '../../components/spinner/spinner-view';
import DateFilter from '../../components/DateFilter';
import DownloadLink from "react-download-link";
import urls from '../../network/urls';
import moment from 'moment';
import Expense from '../../components/expense';
import { format } from '../../helpers/invoiceNumber';

const EXP_COLS = '1.9fr 1fr 1.3fr 0.9fr 0.9fr 0.6fr';

class HomeView extends React.Component {

  state = {
    modal: false,
    pdfModal: false,
    newExpense: {},
    newLineItem: {},
    rankType: 'all',
    search: '',
    showAdd: false
  }

  handleChange = (value, prop) => {
    var t = this.state.newExpense;
    t[prop] = value;
    this.setState({ newExpense: t });
  }

  handleLineChange = (value, prop) => {
    var t = this.state.newLineItem;
    t[prop] = value;
    this.setState({ newLineItem: t });
  }

  handleSearch = (value) => {
    this.setState({ search: value });
  }

  togglePDF = () => {
    this.setState({ pdfModal: !this.state.pdfModal });
  }

  toggle = () => {
    this.setState({ modal: !this.state.modal, newExpense: {} });
  }

  addLineItem = () => {
    this.setState({
      newExpense: {
        ...this.state.newExpense,
        descriptions: this.state.newExpense.descriptions ? [...this.state.newExpense.descriptions, { ...this.state.newLineItem }] : [{ ...this.state.newLineItem }]
      }
    });
  }

  deleteLineItem = (desc) => {
    this.setState({
      newExpense: {
        ...this.state.newExpense,
        descriptions: this.state.newExpense.descriptions.filter(item => item.description != desc)
      }
    });
  }

  edit = (expense) => {
    this.setState({ modal: !this.state.modal, newExpense: expense });
  }

  componentDidMount() {
    if (this.props.selectedCompanyId) {
      this.props.dispatchGetExpenses();
    }
  }

  componentDidUpdate(prevProps) {
    // Reload expenses when selectedCompanyId becomes available or changes
    if (this.props.selectedCompanyId && this.props.selectedCompanyId !== prevProps.selectedCompanyId) {
      this.props.dispatchGetExpenses();
    }
  }

  createExpense = () => {
    this.props.createExpense(this.state.newExpense);
    this.setState({ modal: !this.state.modal, newExpense: '' });
  }

  setRank = (rank) => {
    this.setState({ rankType: rank });
  }

  scrollToTop = () => window.scrollTo(0, 0);

  getDataFromURL = (url, user) => new Promise((resolve, reject) => {
    setTimeout(() => {
      let req = {
        headers: {
          username: user.username,
          token: user.token,
          AUTHORIZATION: user.token
        },
        method: 'GET'
      }

      fetch(url, req)
        .then(response => response.blob())
        .then(data => { resolve(data) });
    });
  }, 2000);

  updateshowAdd = (showAdd) => {
    this.setState({ showAdd })
  }

  render() {
    if (this.props.user && !this.props.user._id) {
      return <Redirect to='/' />
    }

    const isPaid = (p) => p.paid === true || p.paid === 'true';

    let all = 0;
    let paid = 0;
    let un = 0;
    let unTotal = 0;
    let paidTotal = 0;

    let rows = [];
    if (this.props.expenses.expenses.length > 0) {
      rows = this.props.expenses.expenses.map(p => {
        const total = parseFloat((p.price + '').replace(',', '.')) || 0;
        const pPaid = isPaid(p);
        all += 1;
        if (pPaid) { paid += 1; paidTotal += total; }
        else { un += 1; unTotal += total; }

        return {
          id: p._id,
          name: p.client ? (p.client.name + ' ' + (p.client.surname ? p.client.surname : '')).trim() : (p.to || '—'),
          method: p.methodPaid || '',
          expenseNumber: p.expenseNumber,
          expenseDate: p.expenseDate ? moment(p.expenseDate).format('DD MMM YYYY') : '',
          dateRaw: p.expenseDate,
          dueDate: p.dueDate ? moment(p.dueDate).format('DD MMM YYYY') : '',
          dueRaw: p.dueDate,
          paid: pPaid,
          total: 'R ' + format(total),
          totalA: total,
        };
      });
    }

    // Filter (rank + search) then group by status
    const filtered = rows.filter(i => {
      if (this.state.rankType === 'paid') return i.paid;
      if (this.state.rankType === 'unpaid') return !i.paid;
      return true;
    }).filter(i => {
      if (this.state.search === '') return true;
      const q = this.state.search.toLowerCase();
      return (i.name || '').toLowerCase().includes(q) ||
        (i.expenseNumber || '').toString().toLowerCase().includes(q);
    }).sort((a, b) => (a.dateRaw < b.dateRaw ? 1 : -1));

    const today = moment();
    const categorize = (i) => {
      if (i.paid) return 'paid';
      const daysLate = i.dueRaw ? today.diff(moment(i.dueRaw), 'days') : 0;
      return daysLate > 0 ? 'overdue' : 'warn';
    };
    const GROUP_META = {
      overdue: { label: 'Overdue', cls: 'overdue' },
      warn: { label: 'Unpaid', cls: 'warn' },
      paid: { label: 'Paid', cls: 'paid' },
    };
    const groups = { overdue: [], warn: [], paid: [] };
    filtered.forEach(i => groups[categorize(i)].push(i));
    const groupOrder = ['overdue', 'warn', 'paid'];

    const initials = (nm) => (nm || '?').split(' ').filter(Boolean).slice(0, 2).map(w => w[0]).join('').toUpperCase();
    const avColor = (nm) => { let h = 0; for (let c = 0; c < (nm || '').length; c++) h = (h * 31 + nm.charCodeAt(c)) % 6; return h; };

    const totalSpend = paidTotal + unTotal;
    const paidPct = totalSpend > 0 ? Math.round((paidTotal / totalSpend) * 100) : 0;
    const DONUT_CIRC = 263.89;
    const donutOffset = DONUT_CIRC * (1 - paidPct / 100);

    const openExpense = (id) => {
      this.props.getExpense(id, (error) => { if (!error) this.updateshowAdd(true); });
      this.props.selectExpense(id);
    };

    const periodLabel = this.props.global && this.props.global.dateFrom
      ? this.props.global.dateFrom.format('MMMM YYYY')
      : moment().format('MMMM YYYY');

    return (
      <div
        className="content-wrapper p-2 accent-expenses"
        style={{ ['--list-accent']: '#7C5CFC', ['--list-accent-dark']: '#5A3FD6' }}
      >
        <SpinnerView showSpinner={this.props.expenses.loading} />

        {this.state.showAdd && <Expense updateshowAdd={this.updateshowAdd} />}

        {/* Hero band */}
        {!this.state.showAdd && (
          <div className="gl-hero">
            <div className="gl-hero-row">
              <div>
                <div className="gl-hero-title">Expenses</div>
                <div className="gl-hero-sub">{periodLabel} · {all} recorded · {un} unpaid</div>
              </div>
              <div className="gl-hero-actions">
                <Link className="gl-hero-btn" to="/recurring?type=expenses">
                  <i className="fas fa-sync-alt"></i> Recurring
                </Link>
                <DownloadLink
                  label={<><i className="fas fa-arrow-down"></i> Export</>}
                  className="gl-hero-btn"
                  style={{ textDecoration: 'none' }}
                  filename={"sage_import.csv"}
                  exportFile={() => {
                    if (this.props.global) {
                      let url = urls.getExpenses(this.props.selectedCompanyId) + '/export';
                      url = url + '?from=' + this.props.global.dateFrom.format('YYYY-MM-DD');
                      url = url + '&to=' + this.props.global.dateTo.format('YYYY-MM-DD');
                      url = url + '&type=' + this.props.global.dateIndex;
                      return Promise.resolve(this.getDataFromURL(url, this.props.authUser));
                    }
                  }}
                />
                <button
                  className="gl-hero-btn solid"
                  onClick={() => {
                    this.props.dispatchClearExpense();
                    this.updateshowAdd(true);
                  }}
                >
                  <i className="fas fa-plus"></i> New expense
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Summary band */}
        {!this.state.showAdd && (
          <div className="gl-summary">
            <div className="gl-sum-main">
              <div className="gl-sm-eyebrow">Total expenses · {periodLabel}</div>
              <div className="gl-sm-amount-row">
                <div><span className="gl-sm-cur">R </span><span className="gl-sm-num">{format(totalSpend)}</span></div>
              </div>
              <div className="gl-sm-legend">
                <div className="gl-sm-leg-item">
                  <div className="gl-sm-leg-dot" style={{ background: '#fff' }}></div>
                  <div><div className="gl-sm-leg-lbl">Paid</div><div className="gl-sm-leg-val">R {format(paidTotal)}</div></div>
                </div>
                <div className="gl-sm-leg-item">
                  <div className="gl-sm-leg-dot" style={{ background: 'rgba(255,255,255,0.45)' }}></div>
                  <div><div className="gl-sm-leg-lbl">Unpaid</div><div className="gl-sm-leg-val">R {format(unTotal)}</div></div>
                </div>
              </div>
              <svg className="gl-sm-donut" width="104" height="104" viewBox="0 0 110 110">
                <circle cx="55" cy="55" r="42" fill="none" stroke="rgba(255,255,255,0.18)" strokeWidth="10" />
                <circle cx="55" cy="55" r="42" fill="none" stroke="#fff" strokeWidth="10"
                  strokeDasharray={DONUT_CIRC} strokeDashoffset={donutOffset} strokeLinecap="round" transform="rotate(-90 55 55)" />
                <text x="55" y="58" textAnchor="middle" fontFamily="GothamRounded, sans-serif" fontWeight="800" fontSize="22" fill="#fff" dominantBaseline="middle">{paidPct}%</text>
              </svg>
            </div>

            <div className="gl-sum-side">
              <div className="gl-ss-eyebrow">Unpaid</div>
              <div className="gl-ss-amount">R {format(unTotal)}</div>
              <div className="gl-ss-meta">{un} expense{un === 1 ? '' : 's'} outstanding</div>
              {un > 0
                ? <span className="gl-ss-pill danger"><i className="fas fa-circle" style={{ fontSize: 5 }}></i> Needs attention</span>
                : <span className="gl-ss-pill ok"><i className="fas fa-circle" style={{ fontSize: 5 }}></i> All settled</span>}
            </div>

            <div className="gl-sum-side">
              <div className="gl-ss-eyebrow">Paid</div>
              <div className="gl-ss-amount">R {format(paidTotal)}</div>
              <div className="gl-ss-meta">{paid} expense{paid === 1 ? '' : 's'} settled</div>
              <span className="gl-ss-pill ok"><i className="fas fa-check" style={{ fontSize: 8 }}></i> Cleared</span>
            </div>
          </div>
        )}

        {/* Filter bar */}
        {!this.state.showAdd && (
          <div className="gl-filter">
            <div className="gl-seg">
              <button className={`gl-seg-btn ${this.state.rankType === 'all' ? 'active' : ''}`} onClick={() => this.setRank('all')}>All <span className="cnt">{all}</span></button>
              <button className={`gl-seg-btn ${this.state.rankType === 'unpaid' ? 'active' : ''}`} onClick={() => this.setRank('unpaid')}>Unpaid <span className="cnt">{un}</span></button>
              <button className={`gl-seg-btn ${this.state.rankType === 'paid' ? 'active' : ''}`} onClick={() => this.setRank('paid')}>Paid <span className="cnt">{paid}</span></button>
            </div>
            <div className="gl-search">
              <i className="fas fa-magnifying-glass"></i>
              <input placeholder="Filter this list…" value={this.state.search} onChange={(e) => this.handleSearch(e.target.value)} />
            </div>
            <div style={{ marginLeft: 'auto' }}>
              <DateFilter action={this.props.dispatchGetExpenses} />
            </div>
          </div>
        )}

        {/* Status-grouped frosted list */}
        {!this.state.showAdd && (
          <div className="gl-list" style={{ ['--gl-cols']: EXP_COLS }}>
            <div className="gl-list-head">
              <div>Payee</div>
              <div>Expense #</div>
              <div>Date · Due</div>
              <div>Amount</div>
              <div>Status</div>
              <div></div>
            </div>

            {filtered.length === 0 && (
              <div className="gl-empty">No expenses match this view.</div>
            )}

            {groupOrder.map((gk) => {
              const items = groups[gk];
              if (!items || items.length === 0) return null;
              const gsum = items.reduce((s, it) => s + (it.totalA || 0), 0);
              return (
                <React.Fragment key={gk}>
                  <div className="gl-group-head">
                    <span className="lbl">{GROUP_META[gk].label}</span>
                    <span className="count">{items.length}</span>
                    <span className="sum">R {format(gsum)}</span>
                  </div>
                  {items.map((it) => {
                    const days = it.dueRaw ? today.diff(moment(it.dueRaw), 'days') : 0;
                    let statusPill;
                    if (it.paid) statusPill = (<span className="gl-pill paid"><i className="fas fa-check" style={{ fontSize: 8 }}></i> Paid</span>);
                    else if (days > 0) statusPill = (<span className="gl-pill overdue"><i className="fas fa-circle" style={{ fontSize: 6 }}></i> {days}d late</span>);
                    else statusPill = <span className="gl-pill warn">Unpaid</span>;

                    let dueLine = null;
                    if (it.paid) dueLine = <span className="done">Paid</span>;
                    else if (it.dueRaw) dueLine = days > 0
                      ? <span className="late">Due {it.dueDate} · {days}d late</span>
                      : <span className="soon">Due {it.dueDate}</span>;
                    else dueLine = <span>{it.method || 'Unpaid'}</span>;

                    return (
                      <div key={it.id} className={`gl-row ${GROUP_META[gk].cls}`} onClick={() => openExpense(it.id)}>
                        <div className="gl-client">
                          <div className={`gl-av gl-av-${avColor(it.name)}`}>{initials(it.name)}</div>
                          <div style={{ minWidth: 0 }}>
                            <div className="name">{it.name || '—'}</div>
                            {it.method ? <div className="sub">{it.method}</div> : null}
                          </div>
                        </div>
                        <div className="gl-num">{it.expenseNumber ? '#' + it.expenseNumber : '—'}</div>
                        <div className="gl-date">{it.expenseDate}<br />{dueLine}</div>
                        <div className={`gl-amount ${it.paid ? 'paid' : ''}`}>{it.total}</div>
                        <div>{statusPill}</div>
                        <div className="gl-actions" onClick={(e) => e.stopPropagation()}>
                          <button type="button" className="gl-icon-btn" onClick={() => openExpense(it.id)}>
                            <i className="fas fa-arrow-right"></i>
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </React.Fragment>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}
export default HomeView;
